import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

import Loader from "components/Loader";
import lang from "lang";

import { registerServiceWorker } from "serviceWorkerRegistration";

const App = React.lazy(() => import("./App"));

// Используем createRoot вместо ReactDOM.render
const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

createRoot(container).render(
    <Suspense
        fallback={
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Loader animate={false} />
            </div>
        }
    >
        <App />
    </Suspense>
);

registerServiceWorker((wb) => {
    if (window.confirm(lang.system.serviceWorker.update)) {
        wb.messageSkipWaiting();
    }
});
